import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SupplierForm = ({ 
    supplier = null, 
    onSubmit, 
    onCancel, 
    loading = false 
}) => {
    const { t } = useTranslation(['inventory', 'common']);
    const [formData, setFormData] = useState({
        name: '',
        contact_person: '',
        email: '',
        phone: '',
        address: ''
    });

    useEffect(() => {
        if (supplier) {
            setFormData({
                name: supplier.name || '',
                contact_person: supplier.contact_person || '',
                email: supplier.email || '',
                phone: supplier.phone || '',
                address: supplier.address || ''
            });
        }
    }, [supplier]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <form id="supplier-form" onSubmit={handleSubmit}>
            <div className="form-group">
                <label className="form-label">{t('inventory:name')} *</label>
                <input
                    type="text"
                    className="form-input"
                    value={formData.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                    required
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:contact')}</label>
                <input
                    type="text"
                    className="form-input"
                    value={formData.contact_person}
                    onChange={(e) => handleChange('contact_person', e.target.value)}
                />
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">{t('inventory:email')}</label>
                    <input
                        type="email"
                        className="form-input"
                        value={formData.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">{t('inventory:phone')}</label>
                    <input
                        type="tel"
                        className="form-input"
                        value={formData.phone}
                        onChange={(e) => handleChange('phone', e.target.value)}
                    />
                </div>
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:address')}</label>
                <textarea
                    className="form-input"
                    value={formData.address}
                    onChange={(e) => handleChange('address', e.target.value)}
                />
            </div>

        </form>
    );
};

export default SupplierForm;